import React from 'react';

import PropTypes from "prop-types";

const AbstractScreen = ( { id, children, className } ) => {

    return(
        <div className={`screen-${ id } pos-rel screen no-select w-100 ${ className }`}>
            { children }
        </div>
    )
}

AbstractScreen.propTypes = {
    id: PropTypes.string.isRequired,
    children: PropTypes.oneOfType( [ PropTypes.object, PropTypes.array ] ),
    className: PropTypes.string
}

export default AbstractScreen;